import { Guides } from "./components/guides.js";
import { OldBrowserChecker } from "./components/oldBrowserChecker.js";
import { MobileMenu } from "./components/mobileMenu.js";
import { Filter } from "./components/filter.js";
import { LoadMore } from "./components/loadMore.js";
import { Collapsible } from "./components/collapsible.js";
import { HeroAnimation } from "./components/heroAnimation.js";
import { LogoAnimation } from "./components/logoAnimation.js";
import { StickyFooterLogo } from "./components/stickyFooterLogo.js";
import { EmailOverflow } from "./components/emailOverflow.js";
import { PageTitleBottomBar } from "./components/pageTitleBottomBar.js";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

/* -------------------------------------------------- */
/* 🙂 General */
/* -------------------------------------------------- */

gsap.registerPlugin(ScrollTrigger);

/* -------------------------------------------------- */
/* 👵 Check for old browsers */
/* -------------------------------------------------- */

new OldBrowserChecker();

/* -------------------------------------------------- */
/* 📏 Guides */
/* -------------------------------------------------- */

new Guides({
	"(max-width: 1000px)": 4,
});

/* -------------------------------------------------- */
/* 🍔 Mobile menu */
/* -------------------------------------------------- */

new MobileMenu();

/* -------------------------------------------------- */
/* 🔍 Card Filter & Load More */
/* -------------------------------------------------- */

const loadMore = new LoadMore();
new Filter(loadMore);

/* -------------------------------------------------- */
/* 🪗 Collapsibles/accordions */
/* -------------------------------------------------- */

new Collapsible();

/* -------------------------------------------------- */
/* 🦸‍♂️ Hero Animation */
/* -------------------------------------------------- */

new HeroAnimation();

/* -------------------------------------------------- */
/* 💆‍♂️ Logo Animation */
/* -------------------------------------------------- */

new LogoAnimation();

/* -------------------------------------------------- */
/* 🍯 Sticky Footer Logo */
/* -------------------------------------------------- */

// Only initialize if the fixed page title bottom bar is not present
if (document.querySelector(".page-title-bottom-bar") === null) {
	new StickyFooterLogo();
}

/* -------------------------------------------------- */
/* 📧 Email Overflow Detection */
/* -------------------------------------------------- */

new EmailOverflow();

/* -------------------------------------------------- */
/* 📍 Page Title Bottom Bar */
/* -------------------------------------------------- */

new PageTitleBottomBar();
